import useMutationApi from 'src/api/useMutationApi';

type RequestBody = { ms: number };
type ResponseBody = { waitedMs: number };

export default function useTestTimeout() {
  return useMutationApi<RequestBody, ResponseBody, ResponseBody>({
    endpoint: 'qa/test-timeout',
    method: 'POST',
    successMessage: 'Timeout test completed',
    errorMessage: 'Timeout test failed',
    transformResponse: (data) => data,
    showSuccessToast: true,
    showErrorToast: true,
  });
}
